import { CopyTextButton } from "@components/v2/buttons/copy-text-button";
import { Body } from "@components/v2/typography/body";

export const GCSConfigurationInstructions = () => {
  const GCS_SERVICE_ACCOUNT =
    "nb-data-export@north-beam-io.iam.gserviceaccount.com";
  return (
    <div className="flex flex-col gap-4 p-4 rounded-lg border border-v2-tertiary bg-v2-primary shadow-card h-fit">
      <div className="space-y-1">
        <Body variant={200} fontWeight="semibold">
          Grant bucket access to Northbeam
        </Body>
        <Body variant={300} fontWeight="regular">
          Select your GCS bucket and provide Northbeam access into it
        </Body>
      </div>
      <div className="space-y-1">
        <Body variant={200} color="secondary" fontWeight="medium">
          Role:
        </Body>
        <Body variant={300} fontWeight="regular">
          Grant our service account with{" "}
          <span className="font-medium">'Storage Object Admin'</span> role to
          your bucket.
        </Body>
      </div>
      <div className="space-y-1">
        <Body variant={200} color="secondary" fontWeight="medium">
          Service account:
        </Body>
        <CopyTextButton
          textToCopy={GCS_SERVICE_ACCOUNT}
          successMessage="Service account copied to clipboard"
        />
      </div>
    </div>
  );
};
